import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  isErrorDefault = false;
  defaultMessage = '';

  private messageSource = new BehaviorSubject(this.defaultMessage);
  private isErrorSource = new BehaviorSubject(this.isErrorDefault);

  currentMessage = this.messageSource.asObservable();
  currentIsError = this.isErrorSource.asObservable();

  constructor() {
  }

  changeMessage(message: string) {
    this.messageSource.next(message);
  }

  changeIsError(isIt: boolean) {
    this.isErrorSource.next(isIt);
  }
}
